import React from 'react';
import { Link } from 'react-router-dom'
import database from '../../../database.js';
import loading from '../../../img/loading.svg'

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      title: "",
      body: null,
      link: "",
      loaded: false
    }
  }
  componentDidMount() {
    database.collection("learnSections").doc(this.props.id).get().then(function(doc) {
        this.setState({
          title: doc.data().title,
          points: doc.data().points,
          quizLink: doc.data().quizLink,
          link: doc.data().link,
          body: {
            __html: doc.data().body
          },
          loaded: true
        });
        console.log(doc.data().points)
      }.bind(this));

  }
  render() {
    if(this.state.loaded) {
        let pointlist = [];
        let pointLength = (this.state.points)?this.state.points.length:0;
        for (var i = 0; i < pointLength; i++) {
          pointlist.push(
              <li>{this.state.points[i]}</li>);
        }
        return (
          <div className="container"  style={{"paddingTop":"25px"}}>
            <div style={{"marginBottom": "10px"}}><Link to="/learn" className="learn-topic-return" >⏎ Back to Topic List</Link></div>
          <div className="jumbotron">
          <div className="page-header" style={{
            "margin-top":"0px"
          }}>
            <h3> {this.state.title}</h3>
            <a href={this.state.link}>Learn more »</a><br/>
            <a href={this.state.quizLink}>Test your understanding »</a>
          </div>
          <div className="panel">
            <div className="topic-panel-body panel-body" dangerouslySetInnerHTML={this.state.body}>

              {/*<ol style={{
                  "padding-left": "15px"
              }} className="learn-topic-points-list">
                {pointlist}
              </ol>*/}
            </div>
            </div>
          </div>
          </div>
        )
      } else {
        return (
          <div className="learn-topic-loading">
            <img src={loading} />
          </div>
        )
      }
    }

}



// WEBPACK FOOTER //
// ./src/components/Learn/Topic/TopicView.js